$(() => {
    $('body').on('change', '.jsCheckoutAgree', function () {
        if ($(this).prop('checked')) {
            $('.jsButtonContinue').prop('disabled', false);
        } else {
            $('.jsButtonContinue').prop('disabled', true);
        }
    });
});
